import { EQuestionarioUGSituacao, EQuestionarioUGSituacaoDescricao } from "./questionario-ug-situacao.enum";

export  enum ERiscosChavesSituacao{
  EmElaboracao = 1,
  Pendente = 2,
  Avocado = 3,
  Expirado = 4,
  Finalizado = 5,
}

export const ERiscosChavesSituacaoDescricao = {
  [ERiscosChavesSituacao.EmElaboracao]: 'Em Elaboração',
  [ERiscosChavesSituacao.Pendente]: 'Pendente',
  [ERiscosChavesSituacao.Avocado]: 'Avocado',
  [ERiscosChavesSituacao.Expirado]: 'Expirado',
  [ERiscosChavesSituacao.Finalizado]: 'Finalizado',
};
